<template>
  <div class='theme-file__holder' data-vv-value-path='model' :data-vv-as='label'>
    <span class='theme-input__label' v-if="label" v-show="showLabel" >
      {{ label }}
    </span>

    <label :for='id' class='theme-file'>
      <span class='theme-file__btn theme-btn theme-btn--theme theme-btn--small theme-file__desktop-btn' :class="{'theme-file__desktop-btn--white': white, 'theme-file__btn--error': !!errors.has(newName)}">
        <i class='icon-upload' style='font-size: 20px;'/>
        <span class='theme-file__button-text'>
          {{ locales && locales.common && locales.common.choose_file }}
        </span>
      </span>
      <span class='theme-btn theme-btn--theme theme-btn--square theme-btn--square--small theme-file__mobile-btn' :class="{'theme-file__mobile-btn--white': white, 'theme-file__mobile-btn--error': !!errors.has(newName)}">
        <i class='icon-upload' style='font-size: 20px;'/>
      </span>
      <span class='theme-file__text'>
        {{ fileName ? fileName : (locales && locales.common && locales.common.no_file_chosen) }}
      </span>
    </label>

    <div class='theme-input__error-text' v-if='errors.has(newName)'>
      {{ errors.first(newName) }}
    </div>
    <input v-if="multiple"
      style='display: none;'
      :class='inputClass'
      type='file'
      multiple
      :accept='accept'
      :name="name"
      :id='id'
      @change='change'
      :ref="id"
    />
    <input v-else
      style='display: none;'
      :class='inputClass'
      type='file'
      :accept='accept'
      :name="name"
      :id='id'
      @change='change'
      :ref="id"
    />
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import field from '../admin/mixins/field';
  
  export default {
    mixins: [field],
    props: {
      name: {
        default: 'file',
        type: String,
      },
      accept: {
        default: '',
        type: String,
      },
      id: {
        default: '',
        type: String,
      },
      inputClass: {
        default: '',
        type: String,
      },
      white: {
        default: false,
        type: Boolean,
      },
      multiple: {
        default: false,
        type: Boolean,
      },
      showLabel: {
        default: true,
        type: Boolean,
      }
    },
    data() {
      return {
        fileName: '',
      };
    },
    computed: {
      ...mapGetters(["metadata", "locales"])
    },
    methods: {
      change: function(event) {
        this.$emit('change', event);
        if(this.multiple){
          if (event.target.files) {
            var names = [];
            var files = event.target.files;
            for (var i = 0; i < files.length; i++) {
              names.push(files[i].name);
            }
            this.fileName = names.join();
            this.model = names.join();
          } else {
            this.fileName = '';
            this.model = '';
          }
        }else{
          if (event.target.files && event.target.files[0]) {
            this.fileName = event.target.files[0].name;
            this.model = event.target.files[0].name;
          } else {
            this.fileName = '';
            this.model = '';
          }
        }
      },
      clearInput: function () {
        this.fileName = '';
        this.$refs[this.id].value = '';
        this.model = '';
      }
    },
  };
</script>